import { render, staticRenderFns } from "./产权报名.vue?vue&type=template&id=435a909c&scoped=true"
import script from "./产权报名.vue?vue&type=script&lang=js"
export * from "./产权报名.vue?vue&type=script&lang=js"
import style0 from "./产权报名.vue?vue&type=style&index=0&id=435a909c&prod&lang=css"
import style1 from "./产权报名.vue?vue&type=style&index=1&id=435a909c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435a909c",
  null
  
)

export default component.exports